import { Button, createStyles, Theme, Tooltip, Hidden, Zoom, withStyles } from "@material-ui/core";
import { inject, observer } from "mobx-react";
import React from "react";
import { PredefinedRole } from "../../domain/auth/PredefinedRole";
import { PredefinedStoreName } from "../enums/PredefinedStoreName";

import i18n from "../../services/localization/i18n";
import { IContextStoreProps } from "../../stores/IContextStoreProps";
import AppIcon from "../shared/AppIcon";
import { AppIconType } from "../shared/AppIconType";
import meetingDataService from "../../services/api/MeetingDataService";


const styles = (theme: Theme) => createStyles({
    reactivateButton: {
        "&:hover": {
            backgroundColor: theme.palette.success.dark,
        },
        alignSelf: "center",
        backgroundColor: theme.palette.success.main,
        color: theme.palette.getContrastText(theme.palette.success.main),
        height: theme.spacing(6),
        margin: theme.spacing(),
    },
});

interface IReactivateButtonProps {
    classes: {
        reactivateButton : string;
    };
}

interface IReactivateButtonState {
    reactivateTooltip: boolean;
    
}

@inject(PredefinedStoreName.CONTEXT)
@observer
class ReactivateButton extends React.Component<IReactivateButtonProps & IContextStoreProps, IReactivateButtonState> {

    /**
     *Creates an instance of ReactivateButton.
     * @param {(IReactivateButtonProps & IContextStoreProps)} props
     * @memberof ReactivateButton
     */
    constructor(props: IReactivateButtonProps & IContextStoreProps) {
        super(props);

        this.state = {
            reactivateTooltip: false,
        };
    }

    public render() {

        const { classes } = this.props;
        const { role } = this.props.contextStore!;

        const privilegedUser = role === PredefinedRole.POWER_USER || role === PredefinedRole.ADMIN;

        const reactivateCaption = i18n.t("layout_reactivate_button");

        return  <Tooltip
            title={ i18n.t("layout_reactivate_tooltip")! }
            placement="bottom"
            TransitionComponent={Zoom}
            open={this.state.reactivateTooltip}>
                <Button variant="outlined"
                        color="primary"
                        disabled={!privilegedUser}
                        onClick={this.reactivateAsync}
                        onMouseEnter={() => this.setState({reactivateTooltip: true})}
                        onMouseLeave={() => this.setState({reactivateTooltip: false})}
                        className={classes!.reactivateButton}>
                    <>
                        <Hidden smDown={true}>
                            { reactivateCaption}
                        </Hidden>
                        <Hidden mdUp={true}>
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                <AppIcon icon={AppIconType.Unlock} />
                                {reactivateCaption}
                            </div>
                        </Hidden>
                    </>
                </Button>
        </Tooltip>;
    }

    private reactivateAsync = async () => {
        const { resourceId } = this.props.contextStore!;

        await meetingDataService.reactivateAsync(resourceId!)
            .then(() => window.location.reload())

    }
}

export default withStyles(styles)(ReactivateButton);
